<template>
  <div :class="containerClass" @click="goOn">
    <div class="slider">
      <div class="inner">
        <div class="slide"></div>
        <div class="slide">
          <img src="../assets/intro1.png" />
          <h2>Guadagna punti semplicemente avendo l’app installata, in bici o a piedi.</h2>
        </div>
        <div class="slide">
          <img src="../assets/intro2.png" />
          <h2>Guadagna punti semplicemente avendo l’app installata, in bici o a piedi.</h2>
        </div>
        <div class="slide">
          <img src="../assets/intro3.png" />
          <h2>Utilizza i punti nel nostro marketplace, ci trovi meravigliosi premi e offerte speciali.</h2>
        </div>
        <div class="slide">
          <img src="../assets/intro4.png" />
          <h2>
            Segnala luoghi pericolosi, attraversamenti pedonali, scuole.
            Ci piace chiamarle
            HotZones
          </h2>
        </div>
      </div>
    </div>

    <div class="bar-container">
      <button class="avanti">
        Avanti
        <img src="../assets/indietro.svg" />
      </button>
    </div>
    <!--
    <div class="bar-container">
      <img v-if="step==1" class="bar" src="../assets/introbar1.png" />
      <img v-if="step==2" class="bar" src="../assets/introbar2.png" />
      <img v-if="step==3" class="bar" src="../assets/introbar3.png" />
      <img v-if="step==4" class="bar" src="../assets/introbar4.png" />
    </div>-->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Intro",
  components: {},
  methods: {
    goOn() {
      if (this.step > 3) {
        this.$router.replace({
          name: "Home"
        });
      } else {
        this.step += 1;
      }
    }
  },
  data() {
    return {
      step: 0
    };
  },
  computed: {
    containerClass() {
      return "container step" + this.step;
    }
  },
  mounted() {
    if (this.$store.state.showTutorial) {
      window.setTimeout(() => {
        this.step = 1;
      }, 500);
    } else {
      this.$router.replace({
        name: "Home"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.avanti {
  background: rgba(255, 255, 255, 0.8);
  border: none;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  padding: 0.5em 2em;
  border-radius: 3em;
  font-size: 1.1em;
  outline: none;
  align-items: center;
  justify-content: center;
  img {
    transform: rotate(180deg);
    margin-left: 0.5em;
  }
}
.bar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;

  .bar {
    width: 100%;
  }
}
.container {
  flex: 1;
  display: flex;

  align-items: center;

  background: #ebb28d;

  transition: all 1000ms;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.step2 {
    background: #8ab2cf;
  }

  &.step3 {
    background: #9ccf8a;
  }
}

.slider {
  width: 100vw;

  overflow: hidden;
  .inner {
    width: 500vw;
    display: flex;
    flex-direction: row;
    transition: all 500ms;
  }
}

.step1 {
  .inner {
    transform: translate(-20%, 0);
  }
}
.step2 {
  .inner {
    transform: translate(-40%, 0);
  }
}
.step3 {
  .inner {
    transform: translate(-60%, 0);
  }
}
.step4 {
  .inner {
    transform: translate(-80%, 0);
  }
}

.slide {
  h2 {
    color: #fff;
    font-size: 1em;
    padding: 0 20px;
    margin-top: 10px;
  }
  width: 100vw;
  img {
    width: 100%;
  }
}
</style>
